export const currentTeam = [
  {
    name: "Aunsh Bandivadekar",
    title: "Dev",
    socials: [
      "https://deploy-preview-5--helpful-hamster-a151d8.netlify.app/",
      "https://linkedin.com/in/aunsh",
      "https://github.com/aunshx",
    ],
    profilePic: "https://i.postimg.cc/MZRbqn4Y/aunshPic.jpg",
    quote: "MS. ECE @ UC Davis",
  },
  {
    name: "Saipranav Kotamreddy",
    title: "Dev",
    socials: {
      ig: "https://instagram.com/aunsh___",
      linkedIn: "https://instagram.com/in/aunsh",
    },
    profilePic: "https://i.postimg.cc/3NVyH6R8/SPKR.jpg",
    quote: "MS. CS @ UC Davis"
  }
];

export const pastMembers = [
  {},
  {
    name: "Dr. Mohammad Sadoghi",
    title: "Principal & Guide",
    socials: [
      "",
      "https://www.linkedin.com/in/mohammad-sadoghi/",
      ""
    ],
    profilePic: "https://i.postimg.cc/3JCxDmRH/sadoghi.jpg",
  },
  {}
]